// extracted by mini-css-extract-plugin
export default {"button":"primary-icon-full__button___NUdbY primary-icon__button___D4kPf base__button___zT0JW"};